import { render, staticRenderFns } from "./ContactDisplayNameEmailCall.vue?vue&type=template&id=5144f277"
import script from "./ContactDisplayNameEmailCall.vue?vue&type=script&lang=ts"
export * from "./ContactDisplayNameEmailCall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports